module.exports = __webpack_public_path__ + "static/media/img-silver@2x.601a51e2.jpg";